module.exports = __webpack_public_path__ + "static/media/contact-photo-desktop.6f79263a.png";